// What OrderManagementController@goToInvoice answers with (422) when
// XeroService short-circuits on an invoice Xero has already marked PAID.
export const PAID_INVOICE_ERROR = "Paid invoice can not be updated.";

/**
 * The message shown when a save succeeded but the Xero invoice behind it could
 * not be regenerated.
 *
 * Saving a listing from the COSTS step re-posts /order-management/go-to-invoice
 * so a value entered after the invoice was raised — a serial number, a warranty
 * date — still reaches Xero. That call used to be wrapped in a bare
 * `console.log`, so when it failed the rep saw a completely normal successful
 * save while the invoice kept the old description. The most common failure is
 * the one nobody was told about: the invoice is already PAID, Xero will not
 * accept an update, and the correction has to be made in Xero by hand.
 *
 * The listing HAS saved by the time this renders, so the message says so first,
 * then what did not happen, then what to do about it.
 */
export function invoiceNotUpdatedMessage(invoiceNumber, error) {
  const invoice = invoiceNumber
    ? `Xero invoice ${invoiceNumber}`
    : "The Xero invoice";
  const reason = error?.response?.data?.message;

  if (reason === PAID_INVOICE_ERROR) {
    return `Saved. ${invoice} is already paid, so it was not updated — correct it in Xero.`;
  }

  if (reason) {
    return `Saved, but ${invoice} was not updated: ${reason}`;
  }

  return `Saved, but ${invoice} was not updated. Check it in Xero.`;
}
